import request from '@/utils/request'

// 打卡表

let DakaApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.daka/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.daka/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.daka/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.daka/edit', data, errorback);
    },
    /*精选*/
    istop(data, errorback) {
        return request._post('/shop/study.daka/istop', data, errorback);
    },
    /*点赞*/
    like(data, errorback) {
        return request._post('/shop/study.daka/like', data, errorback);
    },
    /*评分*/
    rate(data, errorback) {
        return request._post('/shop/study.daka/rate', data, errorback);
    },

    /*添加评论*/
    addComment(data, errorback) {
        return request._post('/shop/study.comment/add', data, errorback);
    },
    /*评论状态*/
    commentStatus(data, errorback) {
        return request._post('/shop/study.comment/status', data, errorback);
    },
    /*评论状态*/
    commentDel(data, errorback) {
        return request._post('/shop/study.comment/del', data, errorback);
    },
}

export default DakaApi;



// WEBPACK FOOTER //
// ./src/api/study/daka.js